import { View } from "react-native-ui-lib";
import { PageItemType } from "../../../../../../utilities/layout";
import { QuickKey } from "../../../QuickKey";
import {
  useItemRendererContext,
  useMakeCommonQuickKeyProps,
} from "../../hooks";
import { PlaceholderQuickKey } from "../../quick-keys";

export interface PlaceholderItemRendererProps {
  item: PageItemType;
}

export function PlaceholderItemRenderer({
  item,
}: PlaceholderItemRendererProps) {
  const { isEditing, maxTilePosition } = useItemRendererContext();
  const { makeCommonQuickKeyProps } = useMakeCommonQuickKeyProps();
  const common = makeCommonQuickKeyProps(item);

  if (isEditing) {
    return <PlaceholderQuickKey {...common} draggable={false} />;
  } else {
    if (item.position < maxTilePosition) {
      return (
        <View pointerEvents="none" style={{ opacity: 0 }}>
          <QuickKey />
        </View>
      );
    } else {
      return null;
    }
  }
}
